import styled from "styled-components/macro";
import { media } from "../../../../utils";

export const Subtitle = styled.p`
  margin: 0;
`;

export const DownloadButton = styled.button`
  width: 100%;

  ${media.md()} {
    width: auto;
  }
`;

export const FormContent = styled.div`
  ${media.md()} {
    width: 30%;
  }
`;
